import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
    selector: 'app-tree-view',
    templateUrl: './tree-view.component.html',
    styleUrls: ['./tree-view.component.scss'],
})
export class TreeViewComponent implements OnChanges {
    @Input() dropdown: any = [];
    @Input() isGroup: boolean = false;
    @Input() selectedIDList: any = [];
    @Input() roleId: any = [];
    @Input() parentIDList: any = [];
    @Input() subIDList: any = [];
    @Input() control: any = new FormControl();
    @Output() selectedDropdown: EventEmitter<any> = new EventEmitter();
    @Output() messageEvent: EventEmitter<any> = new EventEmitter<string>();

    showTree: boolean = false;
    selectedParentValues: any = [];
    selectedSubValues: any = [];
    placeHolder: any = '';
    showIndex: number = -1;
    isCheckedSelectAll = false;
    ngOnChanges(changes: SimpleChanges): void {
        if (
            changes &&
            changes['dropdown'] &&
            changes['dropdown'].currentValue?.length > 0
        ) {
            this.dropdown = changes['dropdown'].currentValue.map(
                (item: any) => {
                    const { children, ...rest } = item;
                    return {
                        ...rest,
                        isSelected: false,
                        children: children.map((childItem) => {
                            return {
                                ...childItem,
                                parentID: item.value,
                                isSelected: false,
                            };
                        }),
                    };
                }
            );
        }
        if (
            changes &&
            (changes['parentIDList']) &&
            (changes['parentIDList'].currentValue?.length > 0) &&
            this.dropdown &&
            this.dropdown?.length > 0 &&
            !this.isGroup
        ) {
            changes['parentIDList'].currentValue.forEach((element) => {
                const index = this.dropdown.findIndex((item: any) => {
                    return element.id === item.value;
                });
                if (index !== -1) {
                    this.dropdown[index].isSelected = true;
                    this.dropdown[index].children.forEach(
                        (child, childIndex) => {
                            if (
                                changes['subIDList'].currentValue.includes(
                                    child.value.toString()
                                )
                            ) {
                                this.onChildChange(
                                    { checked: true },
                                    index,
                                    childIndex,
                                    child,
                                    element
                                );
                            }
                        }
                    );
                }
            });
            this.submitSelectedDropDown();
        }

        if (
            changes &&
            (
                changes['parentIDList']) &&
            (changes['parentIDList'].currentValue?.length > 0) &&
            this.dropdown &&
            this.dropdown?.length > 0 &&
            this.isGroup
        ) {
            changes['parentIDList'].currentValue.forEach((element) => {
                const index = this.dropdown.findIndex((item: any) => {
                    return element.id === item.value;
                });
                if (index !== -1) {
                    this.dropdown[index].isSelected = true;
                    const subIndex = changes[
                        'subIDList'
                    ].currentValue.findIndex((item) => {
                        return item.id === element.id;
                    });

                    this.dropdown[index].children.forEach(
                        (child, childIndex) => {
                            if (
                                changes['subIDList'].currentValue[
                                    subIndex
                                ]?.userGroup.includes(child.value.toString())
                            ) {
                                this.onChildChange(
                                    { checked: true },
                                    index,
                                    childIndex,
                                    child,
                                    element
                                );
                            }
                        }
                    );
                }
            });
        }
    }

    selectAll(event) {
        this.isCheckedSelectAll = event.checked;
        this.messageEvent.emit(this.isCheckedSelectAll);
        this.dropdown.forEach((item, index) => {
            this.changeDropDownData(index, this.isCheckedSelectAll);
            // if (item?.children && item?.children?.length > 0) {
            // } else {
            //     this.dropdown[index].isSelected = event.checked;
            //     this.submitSelectedDropDown();
            // }
        });
    }

    onParentChange(event: MatCheckboxChange | any, i: number = -1) {
        this.showIndex = i;
        this.isCheckedSelectAll = false;
        this.messageEvent.emit(this.isCheckedSelectAll);
        const index = this.dropdown.findIndex((item: any) => {
            return item.value === (event?.source ? event.source.value : event);
        });
        if (index !== -1 && this.dropdown[index]?.children.length > 0) {
            this.changeDropDownData(index, event.checked);
        } else {
            this.dropdown[index].isSelected = event.checked;
            this.submitSelectedDropDown();
        }
    }

    private changeDropDownData(index: number = -1, status: boolean = false) {
        this.dropdown[index].isSelected = status;
        const dropDownData = this.dropdown[index]?.children?.map(
            (item: any) => {
                return {
                    ...item,
                    isSelected: status,
                };
            }
        );
        this.dropdown[index].children = dropDownData;
        setTimeout(() => {
            this.submitSelectedDropDown();
        }, 200);
    }

    onChildChange(
        event: MatCheckboxChange | any,
        index: number = -1,
        childIndex: number = -1,
        childData: any,
        parentDataId: string = ''
    ) {
        if (event.checked) {
            if (this.dropdown[index].isSelected === undefined)
                this.dropdown[index].isSelected = true;
            else if (!this.dropdown[index].isSelected) {
                this.dropdown[index].isSelected = true;
            }
        }
        if (
            this.dropdown[index]?.children[childIndex]?.isSelected === undefined
        ) {
            this.dropdown[index].children[childIndex].isSelected = true;
        } else {
            this.dropdown[index].children[childIndex].isSelected =
                event.checked;
            this.isCheckedSelectAll = false;
            this.messageEvent.emit(this.isCheckedSelectAll);
        }

        setTimeout(() => {
            this.submitSelectedDropDownFromChild();
        }, 200);
    }

    partiallyComplete(data: any, i: number = -1): boolean {
        if (!data?.children || data.children.length === 0) {
            return false;
        }

        const hasSelectedChildren = data.children.some((t) => t?.isSelected);
        const allChildrenSelected = data.children.every((t) => t?.isSelected);

        // Update parent isSelected only if needed
        if (!hasSelectedChildren) {
            this.dropdown[i].isSelected = false;
        }

        return hasSelectedChildren && !allChildrenSelected;
    }

    submitSelectedDropDown() {
        const parentSelected = this.dropdown
            .filter((item: any) => {
                return item?.isSelected;
            })
            .map((item: any) => {
                const { children, ...rest } = item;
                return rest;
            })
            .flat();

        const childSelected = this.dropdown
            .filter((item: any) => item?.isSelected)
            .map((item: any) => item.children)
            .flat()
            .filter((child: any) => child?.isSelected);
        const totalSelectedData = [...parentSelected, ...childSelected];
        this.placeHolder = totalSelectedData
            .map((item) => item?.item)
            .join(', ');

        this.selectedDropdown.emit(totalSelectedData);
    }

    submitSelectedDropDownFromChild() {
        const parentSelected = this.dropdown
            .filter((item: any) => {
                return item?.isSelected;
            })
            .map((item: any) => {
                const { children, ...rest } = item;
                return rest;
            })
            .flat();

        const childSelected = this.dropdown
            .filter((item: any) => item?.isSelected)
            .map((item: any) => item.children)
            .flat()
            .filter((child: any) => child?.isSelected);
        const totalSelectedData = [...parentSelected, ...childSelected];
        this.placeHolder = totalSelectedData
            .map((item) => item?.item)
            .join(', ');

        // const userGroupByTenant = [{"tenant":"1", userGroup:["123","124"]},{"tenant":"2", userGroup:["13","14"]}]
        // const userGroupByTenant = []

        // totalSelectedData.map((element)=>{
        //     userGroupByTenant.push()
        // })

        this.selectedDropdown.emit(totalSelectedData);
    }
}
